import { render, staticRenderFns } from "./page-list-view-items.vue?vue&type=template&id=198ef9be&scoped=true"
import script from "./page-list-view-items.vue?vue&type=script&lang=js"
export * from "./page-list-view-items.vue?vue&type=script&lang=js"
import style0 from "./page-list-view-items.vue?vue&type=style&index=0&id=198ef9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ef9be",
  null
  
)

export default component.exports